import { CelTabItem } from '@savvaslearning/cel-components/dist-stencil/interfaces/components/cel-tab-panel/cel-tab-panel-interfaces';
import { environment } from '../../../environments/environment';
import { GROWTH_REPORT_PATHS } from '../models/multi-stage-growth-report.model';

export const SIDE_NAVIGATION_TABS = [
  {
    identifier: GROWTH_REPORT_PATHS.OVERALL_SCORE_SUMMARY,
    label: 'side-nav-bar.option.overall-score-summary',
    path: GROWTH_REPORT_PATHS.OVERALL_SCORE_SUMMARY,
  },
  {
    identifier: GROWTH_REPORT_PATHS.DOMAIN_SUMMARY,
    label: 'side-nav-bar.option.domain-summary',
    path: GROWTH_REPORT_PATHS.DOMAIN_SUMMARY,
  },
  {
    identifier: GROWTH_REPORT_PATHS.STUDENT_REPORT,
    label: 'side-nav-bar.option.student-report',
    path: GROWTH_REPORT_PATHS.STUDENT_REPORT,
  },
];

export const TabList: CelTabItem[] = [
  {
    id: 'scale-score',
    ariaControls: '',
    label: 'tab-list.scale-score',
  },
  {
    id: 'metric',
    ariaControls: '',
    label: 'tab-list.metric-measure',
  },
];

export enum GrowthCardSeriesIds {
  StudentGrowthSeries = 'studentGrowth',
  ClassGrowthSeries = 'classGrowth',
  DistrictGrowthSeries = 'districtGrowth',
}

export enum CheckBoxIdentifier {
  ShowGrowth = 'Show growth',
  ShowClassAverage = 'Show class average',
  ShowDistrictAverage = 'Show district avg score',
}

export enum ChartStyleConfigs {
  X_AXIS_FONT_SIZE = '14px',
  Y_AXIS_FONT_SIZE_LARGE = '16px',
  Y_AXIS_FONT_SIZE = '12px',
  Y_AXIS_FONT_SIZE_MEDIUM = '14px',
  X_AXIS_FONT_COLOR = '#333333',
  Y_AXIS_FONT_COLOR = '#333333',
  X_AXIS_FONT_WEIGHT = '600',
  Y_AXIS_FONT_WEIGHT = '400',
  Y_AXIS_FONT_WEIGHT_SEMI_BOLD = '600',
  X_AXIS_FONT_FAMILY = 'OpenSans',
  Y_AXIS_FONT_FAMILY = 'OpenSans',
  X_AXIS_LINE_HEIGHT = '16px',
  Y_AXIS_LINE_HEIGHT = '16px',
}

export enum LineChartMarkerSymbols {
  CIRCLE = 'circle',
  SQUARE = 'square',
}

export enum LineChartDashStyles {
  LongDash = 'LongDash',
}

export enum LineChartLabelAlignments {
  Left = 'left',
  Right = 'right',
}

export enum LoadMsdaModuleErrorMessage {
  StudentScaleScore = 'Error Loading MultiStageReportModule from student scaleScore: ',
  StudentMetric = 'Error Loading MultiStageReportModule from student metric: ',
  OverallMetric = 'Error Loading MultiStageReportModule from overall metric: ',
}

export enum MetricTranslations {
  FOOTER_MESSAGE = 'metric-measure-footer.message',
  ZERO_STATE_MESSAGE = 'metric-measure.zero-state-message',
}

export enum PrintTranslations {
  THIS_STUDENT = 'student-report.print.this-student',
  ALL_STUDENTS = 'student-report.print.all-students',
}

export const PRINT_SCOPE = {
  THIS_STUDENT: 'this-student',
  ALL_STUDENTS: 'all-students',
} as const;

export type PrintScope = (typeof PRINT_SCOPE)[keyof typeof PRINT_SCOPE];

// The width of chart is resized to 700 to fit the 'letter' sized page in the print mode
export const PRINT_CHART_RESIZE_WIDTH = 700;
export const IPAD_PRINT_CHART_RESIZE_WIDTH = 600;

// Delay (ms) for chart animation to complete before printing. All-students print uses longer delay
// since multiple charts resize/redraw simultaneously.
export const PRINT_CHART_RENDER_DELAY_ALL_STUDENTS = 1500;
export const PRINT_CHART_RENDER_DELAY_THIS_STUDENT = 800;

export const MAX_STUDENTS_FOR_PRINT = 50;

export const SCREEN_READER_FIXES = {
  Q_PERIOD_ORIGINAL: 'Q.',
  Q_PERIOD_REPLACEMENT: 'Q\u200B.',
};

export const METRIC_COMPANY_NAME = environment.metricMeasureCompany;
export const REPORTING_TYPE_ORDER = ['BOY', 'MOY', 'EOY'];
